import cn from 'classnames'

import type { PartnerSearchFilterItem } from 'partner360/components/partnerSearchFilter'

import { HighlightMatches } from './components/highlightMatches/HighlightMatches'

import styles from './PartnerSearchRenderItem.module.scss'

interface IPartnerSearchRenderItemProps {
  partner: PartnerSearchFilterItem
  partnerNameClassName?: string
  searchValue: string
}

export const PartnerSearchRenderItem = ({
  partner,
  partnerNameClassName,
  searchValue,
}: IPartnerSearchRenderItemProps) => {
  return (
    <div className={styles.partnerOption}>
      <div className={styles.partnerNameRow}>
        <div className={cn(styles.partnerName, partnerNameClassName)}>
          <HighlightMatches search={searchValue} className={styles.highlight}>
            {partner.PartnerName}
          </HighlightMatches>
        </div>
        {partner.CoveragePercent != null && (
          <div className={styles.coverage}>
            Coverage {Number(partner.CoveragePercent.toFixed(2))}%
          </div>
        )}
      </div>
      <div className={styles.partnerDetails}>
        <div className={styles.marketShortName}>
          <HighlightMatches search={searchValue} className={styles.highlight}>
            {partner.GeoMarketShortName ?? partner.GeoMarket}
          </HighlightMatches>{' '}
          /{' '}
          <HighlightMatches search={searchValue} className={styles.highlight}>
            {partner.Country}
          </HighlightMatches>
        </div>
        <div className={styles.ids}>
          <HighlightMatches search={searchValue} className={styles.highlight}>
            {partner.PartnerId}
          </HighlightMatches>{' '}
          /{' '}
          <HighlightMatches search={searchValue} className={styles.highlight}>
            {partner.LocationId}
          </HighlightMatches>
        </div>
      </div>
    </div>
  )
}
